<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container" data-simplebar>
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-9 col-lg-9 col-xs-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0" v-if="detalhes.cod">

                                        <div class="row">
                                            <div class="col-xl-12 margin-top-0 margin-bottom-10">
                                                <div class="submit-field margin-top-0 margin-bottom-0">
                                                    <h5>
                                                        <i class="material-icons">circle</i>        
                                                        Prêmio selecionado:
                                                    </h5>
                                                </div>
                                            </div>    
                                            <div class="col-xl-8">
                                                <div class="listings-container compact-list-layout margin-top-0">
                                                    <a class="job-listing" style="padding-top: 0px !important; padding-bottom: 0px !important;">
                                                        <div class="job-listing-details">
                                                            <div class="job-listing-company-logo">
                                                                <div class="img" :style="{'background-image': 'url(' + $root.config.url + '/' + detalhes.imagem + ')'}"></div>
                                                            </div>
                                                            <div class="job-listing-description">
                                                                <h3 class="job-listing-title">{{detalhes.nome}}</h3>
                                                                <h4><b>{{detalhes.pontos}}</b> pontos</h4>                                                                                   
                                                                <small style="line-height: 16px; display: block; color: #666" class="margin-top-5">
                                                                    <i class="material-icons" style="font-size: 14px; position: relative; top: 3px;">card_giftcard</i>
                                                                    Após o resgate do prêmio, você ficará com <b>{{$root.user.pontos - detalhes.pontos}} pontos</b>.
                                                                </small>                                                                                   
                                                            </div>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>

                                            <div class="col-xl-12 margin-top-20 margin-bottom-10">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>
                                                        <i class="material-icons">circle</i>        
                                                        Escolha a forma de entrega:
                                                    </h5>
                                                </div>
                                            </div>                                            

                                            <div class="col-xs-6 col-xl-4">
                                                <a class="button-menu shadow border-gray" style="height: 180px;" v-on:click="form.formaEntrega = 'retirar-no-local';" v-bind:class="{'active': form.formaEntrega == 'retirar-no-local'}">
                                                    <i class="material-icons">store</i>
                                                    Retirar em uma filial
                                                </a>
                                            </div>

                                            <div class="col-xs-6 col-xl-4">
                                                <a class="button-menu shadow border-gray" style="height: 180px;" v-on:click="form.formaEntrega = 'entrega';" v-bind:class="{'active': form.formaEntrega == 'entrega'}">
                                                    <i class="material-icons">local_shipping</i>
                                                    Receber no meu endereço
                                                </a>
                                            </div>

                                            <div class="col-xs-12 clearfix" v-show="form.formaEntrega == 'retirar-no-local'">
                                            </div>

                                            <div class="col-xl-5 col-xs-12 margin-top-5" v-show="form.formaEntrega == 'retirar-no-local'">
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>
                                                        <i class="material-icons">circle</i>        
                                                        Qual filial você deseja?
                                                    </h5>
                                                </div>
                                                <select class="with-border" v-model="form.empresaCod">
                                                    <option value="" disabled selected hidden>Selecione aqui..</option>
                                                    <option v-for="item in empresas.itens" :value="item.cod">{{item.nome}}</option>
                                                </select>                                                   
                                                <p class="page-text margin-bottom-10">
                                                    Após a confirmação, você tem até <b>35 dias</b> para retirar o prêmio na filial escolhida.
                                                </p>
                                            </div>                                              

                                            <div class="col-xl-12" v-show="form.formaEntrega == 'entrega'">
                                                <div class="row">

                                                    <div class="col-xl-12 margin-top-5 margin-bottom-15">
                                                        <div class="submit-field margin-bottom-0">
                                                            <h5>
                                                                <i class="material-icons">circle</i>
                                                                Informe seu endereço completo:
                                                            </h5>
                                                        </div>
                                                    </div>                                                  

                                                    <div class="col-xl-10">
                                                        <div class="submit-field">
                                                            <h5>Rua</h5>
                                                            <input type="text" class="with-border" placeholder="Endereço" v-model="form.entregaEndereco">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-2 col-xs-5">
                                                        <div class="submit-field">
                                                            <h5>Número</h5>
                                                            <input type="tel" class="with-border" placeholder="" v-model="form.entregaEnderecoNumero">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-9 col-xs-12">
                                                        <div class="submit-field">
                                                            <h5>Complemento</h5>
                                                            <input type="text" class="with-border" placeholder="" v-model="form.entregaEnderecoComplemento">
                                                        </div>
                                                    </div>
                                            
                                                    <div class="col-xl-3 col-xs-7">
                                                        <div class="submit-field">
                                                            <h5>CEP</h5>
                                                            <the-mask :mask="['#####-###']" :masked="true" type="tel" class="with-border" v-model="form.entregaEnderecoCep" placeholder="Informe aqui" />
                                                        </div>
                                                    </div>
                                            
                                                    <div class="col-xl-4">
                                                        <div class="submit-field">
                                                            <h5>Bairro</h5>
                                                            <input type="text" class="with-border" placeholder="Informe o bairro" v-model="form.entregaEnderecoBairro">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-4">
                                                        <div class="submit-field">
                                                            <h5>Cidade</h5>
                                                            <input type="text" class="with-border" id="cidade" placeholder="Informe o cidade" v-model="form.entregaEnderecoCidade">
                                                        </div>
                                                    </div>

                                                    <div class="col-xl-4">
                                                        <div class="submit-field">
                                                            <h5>Estado</h5>
                                                            <select id="estado" readonly="" class="with-border" name="estado" required="" v-model="form.entregaEnderecoEstado">
                                                                <option value="" disabled selected hidden>Selecione o estado</option>
                                                                <option value="AC">Acre</option>
                                                                <option value="AL">Alagoas</option>
                                                                <option value="AP">Amapá</option>
                                                                <option value="AM">Amazonas</option>
                                                                <option value="BA">Bahia</option>
                                                                <option value="CE">Ceará</option>
                                                                <option value="DF">Distrito Federal</option>
                                                                <option value="ES">Espírito Santo</option>
                                                                <option value="GO">Goiás</option>
                                                                <option value="MA">Maranhão</option>
                                                                <option value="MT">Mato Grosso</option>
                                                                <option value="MS">Mato Grosso do Sul</option>
                                                                <option value="MG">Minas Gerais</option>
                                                                <option value="PA">Pará</option>
                                                                <option value="PB">Paraíba</option>
                                                                <option value="PR">Paraná</option>
                                                                <option value="PE">Pernambuco</option>
                                                                <option value="PI">Piauí</option>
                                                                <option value="RJ">Rio de Janeiro</option>
                                                                <option value="RN">Rio Grande do Norte</option>
                                                                <option value="RS">Rio Grande do Sul</option>
                                                                <option value="RO">Rondônia</option>
                                                                <option value="RR">Roraima</option>
                                                                <option value="SC">Santa Catarina</option>
                                                                <option value="SP">São Paulo</option>
                                                                <option value="SE">Sergipe</option>
                                                                <option value="TO">Tocantins</option>
                                                            </select>                                                   
                                                        </div>
                                                    </div>
                                                </div>
                                                <p class="page-text margin-bottom-10">
                                                    Após a confirmação vamos iniciar a separação do seu pedido, o prêmio será <b>enviado pelos Correios</b> e você receberá o <b>código de rastreamento</b>.
                                                </p>
                                            </div>
                                                                
                                                    
                                            <div class="col-xl-12 margin-bottom-25 margin-top-15" v-show="form.formaEntrega != ''">
                                                <button type="submit" class="button big block-mobile green">
                                                    <i class="material-icons">check_circle</i>
                                                    Confirmar resgate do prêmio
                                                </button>
                                            </div>
                                                
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name:                           'ResgatarPremios',
    components: {
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "loading": {
                "submit":           false
            },
            "form": {
                "acao":             "resgatar",
                "catalogoCod":      "",
                "formaEntrega":     "",
                "enderecoEstado":   "",
                "empresaCod":       "",
                "entregaEnderecoEstado": "",
            },
            "empresas": {
                "itens":            []
            },            
            "detalhes": {

            }            
        }
    },
    methods: {   
        getEmpresas: function() {
            var self        = this;
            console.log("getEmpresas()");
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token
                    }
                };

                axios.get("api/empresas.php", form)
                .then(response => {
                    
                    console.log("getEmpresas() response", response);
                    self.empresas       = response.data.result;
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("getEmpresas() error", error);                    
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        },               
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
                
            axios.post("api/gamification.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                // loading.hide();
                self.$root.tab  = "resgates";
                alert(response.data.message);
                // self.$root.getUser().then(function(result) {
                self.$root.back();
                // });
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/catalogo.php", form)
                .then(response => {
                    
                    console.log("get() response", response);
                    self.detalhes           = response.data.result;
                    self.form.catalogoCod   = response.data.result.cod;
                    self.loaded             = true;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }        
    },    
    created: function() {
        var self = this;
        console.log("created", self);
    
        if (!self.$route.query.c) {
            self.$root.back();
            return false;
        }
        self.form.cod = self.$route.query.c;
        self.get();
        self.getEmpresas();
   
    },
    mounted: function() {
    }    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ResgatarPremios.vue